// 采销工作台 — 常量定义
// 来源：icBot v6.1.15 原型 HTML :root CSS 变量 + 状态映射

// ===== 设计令牌 =====
export const COLORS = {
  primary: '#2563EB',
  primaryHover: '#1D4ED8',
  primaryLight: '#DBEAFE',
  primarySubtle: '#EFF6FF',
  accent: '#F97316',
  accentLight: '#FFF7ED',
  bg: '#FFFFFF',
  bgSidebar: '#F8FAFC',
  bgSecondary: '#F5F7FA',
  surface: '#FFFFFF',
  surfaceHover: '#F8FAFC',
  border: '#E5E7EB',
  borderLight: '#F0F0F0',
  text: '#1F2937',
  textSecondary: '#6B7280',
  textTertiary: '#9CA3AF',
  ready: '#10B981',
  readyBg: '#ECFDF5',
  pending: '#F59E0B',
  pendingBg: '#FFFBEB',
  shortage: '#EF4444',
  shortageBg: '#FEF2F2',
  radius: '6px',
  radiusLg: '8px',
  // 兼容别名
  blue: '#2563EB',
  blueLight: '#DBEAFE',
  green: '#10B981',
  greenLight: '#ECFDF5',
  orange: '#F59E0B',
  orangeLight: '#FFFBEB',
  red: '#EF4444',
  redLight: '#FEF2F2',
  // 能力标签色
  capAi: '#8B5CF6',
  capAiBg: '#EDE9FE',
  capHuman: '#3B82F6',
  capHumanBg: '#DBEAFE',
  capSystem: '#10B981',
  capSystemBg: '#D1FAE5',
  capSupplier: '#F59E0B',
  capSupplierBg: '#FEF3C7',
  capManager: '#EF4444',
  capManagerBg: '#FEE2E2',
  capErp: '#0D9488',
  capErpBg: '#CCFBF1'
}

// ===== 状态样式映射 =====
export const STATUS_MAP = {
  created: {
    key: 'created',
    icon: '⏳',
    label: '待确定',
    cls: 'created',
    color: '#92400E',
    bg: '#FFFBEB'
  },
  in_progress: {
    key: 'in_progress',
    icon: '🔄',
    label: '询价中',
    cls: 'in_progress',
    color: '#2563EB',
    bg: '#EFF6FF'
  },
  quoting: {
    key: 'quoting',
    icon: '📋',
    label: '待报价',
    cls: 'quoting',
    color: '#065F46',
    bg: '#ECFDF5'
  },
  completed: {
    key: 'completed',
    icon: '✅',
    label: '已报价',
    cls: 'completed',
    color: '#065F46',
    bg: '#ECFDF5'
  },
  won: {
    key: 'won',
    icon: '🏆',
    label: '已成交',
    cls: 'won',
    color: '#065F46',
    bg: '#ECFDF5'
  },
  lost: {
    key: 'lost',
    icon: '❌',
    label: '丢单',
    cls: 'lost',
    color: '#991B1B',
    bg: '#FEF2F2'
  }
}

// ===== 状态筛选 Tab 定义 =====
export const FILTER_TABS = [
  { key: null, label: '全部询价' },
  { key: 'created', label: '待确定' },
  { key: 'in_progress', label: '询价中' },
  { key: 'quoting', label: '待报价' },
  { key: 'completed', label: '已报价' },
  { key: 'won', label: '已成交' },
  { key: 'lost', label: '丢单' }
]

// ===== 视图定义 =====
export const VIEW_TABS = [
  { key: 'sales', label: '销售' },
  { key: 'procure', label: '采购' },
  { key: 'manager', label: '管理' },
  { key: 'pm', label: 'PM' }
]

// ===== 视图标题 =====
export const VIEW_TITLES = {
  sales: '销售视图',
  procure: '采购视图',
  manager: '管理者看板',
  pm: '产品经理'
}

// ===== 丢单原因选项 =====
export const LOSS_REASONS = [
  '价格高于竞品',
  '交期不满足',
  '批次不符合要求',
  '客户取消项目',
  '供应商无法供货',
  '客户已从其他渠道采购',
  '其他原因'
]

// ===== 采购求助类型 =====
export const HELP_TYPES = [
  '供应商无库存',
  '价格高于客户目标价',
  'MOQ 不满足',
  '交期无法满足',
  '型号已停产(EOL)'
]

// ===== 毛利率选项 =====
export const MARGIN_OPTIONS = [
  { value: 10, label: '10%' },
  { value: 15, label: '15%' },
  { value: 20, label: '20%' }
]

// ===== 价格类型 =====
export const PRICE_TYPES = {
  a: { label: 'a', tip: 'API自动匹配·第三方平台查价', color: '#2563EB', bg: '#EFF6FF' },
  A: { label: 'A', tip: '采购人工询供录入', color: '#16A34A', bg: '#F0FDF4' },
  I: { label: 'I', tip: '公司自有库存', color: '#9333EA', bg: '#FAF5FF' },
  O: { label: 'O', tip: '供应商公开挂牌价', color: '#6B7280', bg: '#F9FAFB' }
}

// ===== 新建任务选项 =====
export const NEW_TASK_OPTIONS = {
  sales: [
    { key: 'single', label: '单料询价', desc: '输入单个型号，快速发起询价' },
    { key: 'bom', label: 'BOM询价', desc: '上传BOM文件或粘贴料号列表' },
    { key: 'order', label: '已接单录入', desc: '已确认的客户订单，直接录入系统' },
    { key: 'batch', label: '批量录入', desc: 'Excel批量导入多条询价' }
  ],
  procure: [
    { key: 'manual', label: '手动录报价', desc: '收到供应商报价，录入系统' },
    { key: 'batch_price', label: '批量录报价', desc: 'Excel批量导入供应商报价' }
  ]
}
